import { useSelector } from "react-redux";
import { titleSuffixSelector } from "../store/layout";
import { useMemo } from "react";

export default function useTitle() {
  const titleSuffix = useSelector(titleSuffixSelector);

  return useMemo(() => {
    if (titleSuffix)
      return 'Legal Panel ' + titleSuffix;
    else
      return 'Legal Panel';
  }, [titleSuffix]);
}
